<template>
    <v-ons-page>
        <div class="page-header">
            <img src="../assets/hynds-vip.svg" width="74px" style="width:74px;" class="logo">
        </div>
        <div v-show="initialized">
            <div class="copy copy--intro">
                <div v-if="contentExpanded" v-html="tripContent" class="truncated-content"></div>
                <div v-else v-html="clippedContent" class="truncated-content"></div>
                <div class="d-flex align-items-center justify-content-center mt-2 mb-3">
                    <v-ons-button modifier="cta sm auto" @click="toggleTruncatedContent()">Show {{ contentExpanded ? 'Less' : 'More' }}</v-ons-button>
                </div>

            </div>

            <v-ons-row>
                <v-ons-col>
                    <div class="mt-2 mb-3">
                        <h2>Your {{ currentYear }} target trip is:</h2>
                    </div>
                    <v-ons-card>
                        <div class="card__image">
                            <a href="javascript:void(0)" @click="goToTrip(currentTrip)">
                                <img :src="imgPath(_.get(currentTrip, 'attributes.image'))"
                                    :alt="_.get(currentTrip, 'attributes.image.name')">
                            </a>
                            <span class="card__image__year">{{ _.get(currentTrip, 'attributes.year')}}</span>
                            <div v-if="_.get(currentTrip, 'attributes.trip_type') == 'Gold'" class="card__persons">
                                <div class="person-icon">
                                    <span class="person-count">{{ _.get(currentTrip, 'attributes.pax') }}</span>
                                </div>
                            </div>
                        </div>
                        <div v-if="qualified" class="title title--complete card__title">
                            <h2>{{ _.get(currentTrip, 'attributes.name') }}</h2>
                            <p>{{ _.get(currentTrip, 'attributes.confirmation_message') }}</p>
                        </div>
                        <template v-else>
                        <div class="title" @click="goToTrip(currentTrip)">
                            {{ _.get(currentTrip, 'attributes.name') }}
                        </div>
                        <div class="content" @click="goToTrip(currentTrip)">
                            <div class="progress-container">
                                <span>Your progress</span>
                                <em v-if="_.get(currentTrip, 'attributes.percentage') >= 100" class="progress-note text-success">Trip earned!</em>
                                <em v-else-if="_.get(currentTrip, 'attributes.percentage') >= 90" class="progress-note text-success">Nearly there!</em>

                                <span v-if="getTripStatus(currentTrip)"
                                    >{{ _.get(currentTrip, 'attributes.trip_type') == 'Gold' ? _.get(currentTrip, 'attributes.percentage')+'%' : '$'+_.get(currentTrip, 'attributes.percentage')+'K' }}</span>
                            </div>
                            <v-ons-progress-bar :value="_.get(currentTrip, 'attributes.percentage')"></v-ons-progress-bar>

                            <p class="intro" v-if="_.get(currentTrip, 'attributes.intro')">{{ _.get(currentTrip, 'attributes.intro') }}</p>

                        </div>
                        </template>

                    </v-ons-card>
                </v-ons-col>
            </v-ons-row>

            <v-ons-row v-if="earnedTrips.length > 1" class="mb-4">
                <v-ons-col class="content-col">
                    <v-ons-button @click="$router.push({ name: 'trips' })"
                        class="button button--primary">
                        View your trips
                    </v-ons-button>
                </v-ons-col>
            </v-ons-row>

        </div>
        <div v-show="!initialized" class="text-center page-progress-loader">
            <v-ons-progress-circular
                indeterminate
                ></v-ons-progress-circular>
        </div>

    </v-ons-page>
</template>

<script>
import Utils from './mixins/Utils'
import Module from './mixins/Module'
import clip from 'text-clipper'

export default {
    data () {
        return {
            initialized: false,
            currentTrip: null,
            contentExpanded: false,
        }
    },
    components: {
    },
    created() {
        this.$emit('init', {
            name: 'home',
            title: 'Dashboard',
            showMenu: true,
            showFooter: false,
        })

        if (!this.customer.content.id) {
            return this.$router.push('login')
        }

        this.trips.getInitialData('/my/all_trips', {
            token: this.getToken(),
        }).then((trips) => {
            this.currentTrip = _.find(trips.data, (t) => {
                return _.get(t, 'attributes.default');
            })
        })

        // let pageId = this.$route.params.id;
        this.page.getInitialData(`/pages/15`, {
            token: this.getToken(),
        }).then((res) => {
            this.$emit('init', {
                name: 'page',
                title: 'Dashboard',
                showMenu: true,
            })
            this.initialized = true;
        })
    },

    mounted() {

    },

    mixins: [
        Utils,
        Module('customer'),
        Module('trips'),
        Module('page'),

    ],
    computed: {
        pageData() {
            return _.get(this.page, 'content') || {}
        },
        customerPax() {
            return _.get(this.customer, 'content.attributes.persons')
        },
        currentYear() {
            return _.get(this.currentTrip, 'attributes.year', new Date().getFullYear());
            // return new Date().getFullYear();
        },
        qualified() {
            return _.get(this.currentTrip, 'attributes.percentage') >= 100;
        },
        earnedTrips() {
            let trips = this.trips.content.data;

            return _.filter(trips, (trip) => {
                return trip.attributes.percentage >= 100;
            });
        },
        hasEarnedTrips() {
            return this.earnedTrips.length > 0;
        },

        tripContent() {
            const customerType = _.get(this.customer, 'content.attributes.customer_type');
            if (customerType == 'Gold') {
                return _.get(this.pageData, 'attributes.content_gold')
            } else {
                return _.get(this.pageData, 'attributes.content_jade')
            }
        },

        clippedContent() {
            const clippedHtml = clip(this.tripContent, 190, {html: true, maxLines: 5});
            return clippedHtml;
        }
    },
    methods: {
        goToTrip(trip) {
            if (!this.getTripStatus(trip)) {
                return false;
            }

            this.$router.push({
                name: 'trip',
                params: {
                    id: trip.id
                }
            })
        },

        getTripStatus(trip) {
            if (this.currentTrip && trip.id == this.currentTrip.id) {
                return true;
            }

            return false;
        },

        toggleTruncatedContent() {
            this.contentExpanded = this.contentExpanded ? false : true;
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo {
    margin-bottom: 6px;
}
img {
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/HomePage.vue